import { CanaryPhase } from './types';

export const DEFAULT_CANARY_PHASES: CanaryPhase[] = [
  { targetPercentage: 10, durationMins: 30 },
  { targetPercentage: 25, durationMins: 60 },
  { targetPercentage: 100, durationMins: 120 },
];

export const normalizeCanaryPhases = (
  phases?: CanaryPhase[],
): CanaryPhase[] => {
  const normalized =
    phases?.map((phase) => ({ ...phase })) ??
    DEFAULT_CANARY_PHASES.map((phase) => ({ ...phase }));

  if (normalized.length === 0) {
    return DEFAULT_CANARY_PHASES.map((phase) => ({ ...phase }));
  }

  const finalPhaseIndex = normalized.length - 1;
  normalized[finalPhaseIndex] = {
    ...normalized[finalPhaseIndex],
    targetPercentage: 100,
  };

  return normalized;
};

export const insertCanaryPhaseBeforeFinal = (
  phases: CanaryPhase[],
): CanaryPhase[] => {
  const normalized = normalizeCanaryPhases(phases);
  const finalPhaseIndex = normalized.length - 1;
  const previousPercentage =
    normalized[finalPhaseIndex - 1]?.targetPercentage ?? 0;
  const targetPercentage = Math.min(
    99,
    previousPercentage +
      Math.max(1, Math.floor((100 - previousPercentage) / 2)),
  );

  return [
    ...normalized.slice(0, finalPhaseIndex),
    { targetPercentage, durationMins: 30 },
    normalized[finalPhaseIndex],
  ];
};

export const removeEditableCanaryPhase = (
  phases: CanaryPhase[],
  index: number,
): CanaryPhase[] => {
  const normalized = normalizeCanaryPhases(phases);
  const isFinalPhase = index === normalized.length - 1;

  if (normalized.length <= 3 || isFinalPhase) {
    return normalized;
  }

  return normalized.filter((_, phaseIndex) => phaseIndex !== index);
};
